import { Injectable } from '@angular/core';
import {
  OrderCheckoutModel, OrderPayloadModel, OrderTokenModel,
} from '@libs/shop/models';
import { CartService } from '@libs/shared/services';
import { DateTime } from 'luxon';
import { defer, finalize, Observable, tap } from 'rxjs';
import { CapacitorService, SpinnerOverlayService } from '@libs/shared/common';
import { CheckoutRepositoryService } from './checkout-repository.service';

@Injectable({ providedIn: 'root' })
export class CheckoutService {
  public constructor(
    private readonly repository: CheckoutRepositoryService,
    private readonly cartService: CartService,
    private readonly spinnerOverlayService: SpinnerOverlayService,
    private readonly capacitorService: CapacitorService,
  ) {
  }

  public placeOrder(cartId: string, orderToken: string, requestedDeliveryDate?: DateTime | null, orderCustomReferenceText?: string): Observable<OrderCheckoutModel> {
    return defer(() => {
      this.spinnerOverlayService.showLoader();
      const payload: OrderPayloadModel = {
        type: 'lekkerland-orders',
        id: '',
        cartId,
        orderToken,
        orderChannel: this.capacitorService.isCapacitorApp() ? 'APP2' : 'WEB2',
        requestedDeliveryDate: requestedDeliveryDate?.toISODate() ?? undefined,
        orderCustomReference: orderCustomReferenceText,
      };

      return this.repository.placeOrder(payload).pipe(
        tap(checkoutResult =>
          void this.cartService.setCartId(checkoutResult.newCartId)),
      );
    }).pipe(
      finalize(() => void this.spinnerOverlayService.hideLoader()),
    );
  }

  public getOrderToken(cartId: string): Observable<OrderTokenModel> {
    return this.repository.getOrderToken(cartId);
  }
}
